module.exports = __webpack_public_path__ + "b5c19f6bd248662b3a14e74688434c1e.png";